// Games tab: game tables grouped by day and field

import GameReport from './GameReport';
import GameReportGroup from './GameReportGroup';
import GameReportSection from './GameReportSection';
import GameListPDF from './GameListPDF';
import { useGameReport } from '../utils/hooks';
import {
  getGamesByField,
  countGames,
  totalGamesOn,
} from '../utils/gameReport';

export default function GameList({ id, colorLegend }) {
  const { days, sortedGames, sortedFields } = useGameReport(id);

  return (
    <GameReport
      id={id}
      colorLegend={colorLegend}
      documentTitle='Games'
      pdf={<GameListPDF id={id} colorLegend={colorLegend} />}
    >
      {days.map((day, i) => {
        const gamesByField = getGamesByField(sortedGames, day, sortedFields);

        return (
          <GameReportGroup
            key={i}
            title={day.format('MMMM D, YY')}
            total={totalGamesOn(day.format('MMMM D'), countGames(gamesByField))}
          >
            {gamesByField.map(({ field, games }) => (
              <GameReportSection
                key={field.id}
                title={field.name}
                total={totalGamesOn(field.name, games.length)}
                games={games}
                fields={sortedFields}
                colorLegend={colorLegend}
                noFieldCol
              />
            ))}
          </GameReportGroup>
        );
      })}
    </GameReport>
  );
}
